import drivers from './drivers';
import people from './people';
import users from './users';
import contacts from 'views/screens/Contacts/sidebarLayout';

export default [
  {
    id: 'catalogs',
    title: 'sidebar.catalogs',
    icon: 'Users',
    permissions: [],
    iconName: 'Users',
    children: [...users, ...drivers, ...people, ...contacts]
  }
];
